module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-bottom.1eb3b0a4.svg";